export const ProgressChartTooltip = ({ active, payload, label, rows = [] }) => {
  if (!active || !payload?.length) return null;

  const point = payload[0]?.payload;
  const heading = label ?? point?.range_label ?? point?.label ?? null;

  const visibleRows = rows.filter((row) => row?.value != null && row.value !== "");

  if (visibleRows.length === 0) return null;

  return (
    <div className="chart-tooltip font-mono max-w-xs shadow-lg">
      {heading ? <div className="text-dark-text-muted mb-2">{heading}</div> : null}
      {visibleRows.map((row, index) => (
        <div key={`${row.label || "value"}-${index}`} className={index > 0 ? "mt-1" : undefined}>
          {row.label ? <span className="text-dark-text-muted">{row.label}: </span> : null}
          <span className="text-dark-text-primary">{row.value}</span>
        </div>
      ))}
    </div>
  );
};
